import { Map, Record } from "immutable";
import { RootActions, RootState } from "common/reducers";
import { PatternRecord, patternFromJSON } from "common/records/Pattern";
import { patternTestDataFromJSON } from "common/records/PatternTestData";
import { receive, reset } from "common/reducers/Utils";
import {
  PatternActions,
  RECEIVE_PATTERN,
  RECEIVE_PATTERNS,
  REMOVE_PATTERN,
  RESET_PATTERN,
} from "common/reducers/pattern.actions";

export const PatternStateRecord = Record({
  byId: Map<number, PatternRecord>(),
  lastSavedById: Map<number, PatternRecord>(),
  testData: patternTestDataFromJSON({}),
});

export const initialState = PatternStateRecord();

export type OrgState = typeof initialState;

export const initialOrgRecord = Record({ patterns: initialState })();
export type OrgRootRecord = typeof initialOrgRecord;

const model = "patterns";
export const reducer = (state: RootState, action: RootActions): RootState => {
  if (state && !state.get(model)) {
    state = state.set(model, initialState);
  }
  switch (action.type) {
    case RECEIVE_PATTERN: {
      const pattern = patternFromJSON(action.payload);
      state = receive(state, model, pattern) as RootState;
      return state;
    }

    case RECEIVE_PATTERNS:
      action.payload.patterns.forEach((pattern) => {
        state = reducer(state, PatternActions.receivePattern(pattern));
      });
      return state;

    case REMOVE_PATTERN:
      return state.removeIn([model, "byId", action.payload]).removeIn([model, "lastSavedById", action.payload]);

    case RESET_PATTERN:
      return reset(state, model, action.payload) as RootState;

    default:
      return state;
  }
};
